import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const TrainerTestimonial = ({ testimonial }) => {
  return (
    <div className="bg-card border border-border rounded-xl shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-start gap-4 mb-4">
        <div className="flex-shrink-0">
          <Image
            src={testimonial?.memberImage}
            alt={testimonial?.memberImageAlt}
            className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover"
          />
        </div>
        <div className="flex-1">
          <div className="flex items-center justify-between mb-1">
            <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
              {testimonial?.memberName}
            </h4>
            <div className="flex items-center gap-1">
              {[...Array(5)]?.map((_, index) => (
                <Icon
                  key={index}
                  name="Star"
                  size={14}
                  color={index < testimonial?.rating ? 'var(--color-warning)' : 'var(--color-muted)'}
                  fill={index < testimonial?.rating ? 'var(--color-warning)' : 'none'}
                />
              ))}
            </div>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground caption">
            {testimonial?.program} • {testimonial?.duration}
          </p>
        </div>
      </div>
      <p className="text-sm md:text-base text-foreground mb-4 leading-relaxed">
        "{testimonial?.review}"
      </p>
      <div className="flex flex-wrap gap-3 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 bg-success/10 rounded-lg">
            <Icon name="TrendingUp" size={16} color="var(--color-success)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground caption">Weight Lost</p>
            <p className="text-sm font-bold data-text text-foreground">{testimonial?.weightLost}</p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center justify-center w-8 h-8 bg-accent/10 rounded-lg">
            <Icon name="Zap" size={16} color="var(--color-accent)" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground caption">Strength Gain</p>
            <p className="text-sm font-bold data-text text-foreground">{testimonial?.strengthGain}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainerTestimonial;